import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getDetailEvaluationStart,
  getDetailEvaluationSuccess,
  getDetailEvaluationFailed,
} from "../redux/getDetailEvaluation";
import { getDetailEvaluationApi } from "core/http/service/evaluation";

function* getDetailEvaluationWork(
  action: ReturnType<typeof getDetailEvaluationStart>
) {
  const payload = action.payload;

  try {
    const res = yield call(getDetailEvaluationApi, payload);
    yield put({
      type: getDetailEvaluationSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getDetailEvaluationFailed.type,
    });
  }
}

function* watchGetDetailEvaluation() {
  yield takeLatest(getDetailEvaluationStart.type, getDetailEvaluationWork);
}

export default function* getDetailEvaluationSaga() {
  yield all([watchGetDetailEvaluation()]);
}
